import React, { useState } from "react";
import { Link } from "react-router-dom";
import BlackLogo from "../../images/Siamois/logo/logo-black.svg";
import {useMediaQuery} from "@material-ui/core";
import {useHistory} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {fetchLoginUser} from "../../redux/actions/actions";
import swal from "sweetalert";

const Login = () => {
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl= useMediaQuery('(min-width:1200px)');
    let history=useHistory();
    const dispatch =useDispatch();
    const user = useSelector(state => state.user);

    const [loginData, setLoginData] = useState({email : "" , password : ""});
    const handleBlur = (e) => {
        const newLoginData = { ...loginData };
        newLoginData[e.target.name] = e.target.value;
        setLoginData(newLoginData);
    };
    const submitHandler = () => {
        console.log('Login Data =', loginData);
        dispatch(fetchLoginUser(loginData))
            .then(res=>{
                history.push('/')
            })
            .catch(err=>{
                swal(
                    user.login.error,
                    "",
                    "error"
                )
            })
    };
    return (
        <React.Fragment>
            <div className="d-flex justify-content-center mt-1">
                <img style={ {height : lg ? '5rem' : '3rem'} } src={BlackLogo} alt=""/>
            </div>
            <div className="authincation mt-3 mb-4">
                <div className="container p-0">
                    <div className="row justify-content-center align-items-center authincation-page-area">
                        <div className="col-lg-6 col-md-9">
                            <div className="authincation-content">
                                <div className="row no-gutters">
                                    <div className="col-xl-12">
                                        <div className="auth-form">
                                            <h4 className="text-center mb-4">
                                                Sign in your account
                                            </h4>
                                            <form
                                                action=""
                                                onSubmit={(e) =>
                                                    e.preventDefault(submitHandler)
                                                }
                                            >
                                                <div className="form-group">
                                                    <label className="mb-1">
                                                        <strong>Email</strong>
                                                    </label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        onChange={handleBlur}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="mb-1">
                                                        <strong>Password</strong>
                                                    </label>
                                                    <input
                                                        type="password"
                                                        className="form-control"
                                                        name="password"
                                                        onChange={handleBlur}
                                                    />
                                                </div>
                                                <div className="form-row d-flex justify-content-between mt-4 mb-2">
                                                    <div className="form-group">
                                                        <Link to="/page-forgot-password">
                                                            Forgot Password?
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="text-center">
                                                    <button
                                                        className="btn btn-primary btn-block"
                                                        onClick={() => submitHandler()}
                                                        disabled={ !loginData.email.length || !loginData.password.length || user.login.loading }
                                                    >
                                                        Sign Me In
                                                    </button>
                                                </div>
                                            </form>
                                            <div className="new-account mt-3">
                                                <p>
                                                    Don't have an account?{" "}
                                                    <Link
                                                        className="text-primary"
                                                        to="/registration"
                                                    >
                                                        Sign up
                                                    </Link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>

    );
};

export default Login;
